<template>
  <div>
    <img
      v-if="dynamicContent.CreateAccount.metadata.imageUrl"
      class="image image--logo"
      :alt="merchant.name"
      :src="dynamicContent.CreateAccount.metadata.imageUrl"
    >

    <h2
      v-if="dynamicContent.CreateAccount.title"
      class="title title--2"
    >
      {{ dynamicContent.CreateAccount.title }}
    </h2>

    <p class="bigger">{{ dynamicContent.CreateAccount.metadata.subtitle }}</p>

    <div
      v-if="dynamicContent.CreateAccount.metadata.attributes.length > 0"
      class="create-account-attribute-group"
    >
      <div
        v-for="attribute in dynamicContent.CreateAccount.metadata.attributes"
        :key="attribute.attributeText"
      >
        <img
          v-if="attribute.iconUrl"
          class="image image--icon half-spacing"
          :alt="attribute.attributeText"
          :src="attribute.iconUrl"
        >

        <h3 class="title title--7">{{ attribute.attributeText }}</h3>
      </div>
    </div>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'CreateAccountHeader',

    computed: {
      ...mapGetters('content', ['dynamicContent']),
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>

<style lang="sass">
  .create-account-attribute-group
    display: grid
    grid-auto-flow: column
    grid-auto-columns: 1fr
    gap: 1rem
</style>
